import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin, Settings } from "lucide-react";

interface SiteCreationTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectManual: () => void;
  onSelectFromProject: () => void;
}

export const SiteCreationTypeModal = ({ 
  isOpen, 
  onClose, 
  onSelectManual, 
  onSelectFromProject 
}: SiteCreationTypeModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Nieuwe locatie aanmaken</DialogTitle>
          <DialogDescription>
            Kies hoe je de nieuwe locatie wilt aanmaken
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-4 mt-4">
          <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={onSelectFromProject}>
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-lg">
                <Settings className="h-5 w-5 text-primary" />
                Vanuit project
              </CardTitle>
              <CardDescription>
                Maak een locatie aan vanuit een afgerond project
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full" onClick={onSelectFromProject}>
                Kies project
              </Button>
            </CardContent>
          </Card>

          <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={onSelectManual}>
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-lg">
                <MapPin className="h-5 w-5 text-primary" />
                Handmatig
              </CardTitle>
              <CardDescription>
                Maak een locatie aan door alle gegevens handmatig in te voeren
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" onClick={onSelectManual}>
                Handmatig aanmaken
              </Button>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
};